import React from 'react';
import { map } from 'lodash';
import Link from 'components/link'


const Links = (props) => {
  const links = props.links.reverse();

  const list = (links) => (
      <div className="links-container">
        <h3>Recently Shortened</h3>
        <h4>All clicks</h4>
        {map(links, link => <Link {...link} key={link.id}/>)}
      </div>
  )


  return (
      <div className="background-grey">
        {links.length > 0 ? list(links) : ''}
      </div>
  );
}

export default Links;


// WEBPACK FOOTER //
// ./src/components/Links.jsx